
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps } from 'next';
import MediaTemplateLandingPage from '@/components/templates/MediaTemplateLandingPage';
import { getMediaTemplatesByKind, ImageTool, MEDIA_TEMPLATE_LANDING_LOCALES, } from '@/constants/mediaTemplates';
interface VideoTemplatePageProps {
    template: ImageTool;
}
const VideoTemplatePage = ({ template }: VideoTemplatePageProps) => (<MediaTemplateLandingPage template={template} kind='video' parentPath='/ai-video-generator' parentLabel='AI Video Generator'/>);
export const getStaticPaths: GetStaticPaths = async () => {
    const templates = getMediaTemplatesByKind('video').filter((template): template is ImageTool & {
        slug: string;
    } => Boolean(template.slug));
    const paths = templates.flatMap((template) => MEDIA_TEMPLATE_LANDING_LOCALES.map((locale) => ({
        params: { slug: template.slug },
        locale,
    })));
    return {
        paths,
        fallback: false,
    };
};
const getStaticProps: GetStaticProps<VideoTemplatePageProps> = async ({ params, }) => {
    const template = getMediaTemplatesByKind('video').find((item) => item.slug === params?.slug);
    if (!template) {
        return { notFound: true };
    }
    return {
        props: {
            template,
        },
    };
};
export default VideoTemplatePage;

    async function __Next_Translate__getStaticProps__1a0ced21c66__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-video-generator/templates/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0ced21c66__ as getStaticProps }
  